import { FormFieldState } from '../types';
import { ScheduleR0 } from '@buy-viasat/types/build/bv';

export const defaultInstallationDate: InstallationDate = {
  month: null,
  year: null,
  day: null,
};

export const defaultInstallation: SelectedInstallation = {
  ...defaultInstallationDate,
  timezone: '',
  arrivalWindow: '',
  note: '',
};

export type ScheduleInstallationState = {
  availableInstallationDates: AvailableInstallationDates;
  calendarDate: CalendarDate;
  loadingInstallationDates: boolean;
  selectedInstallation: FormFieldState<SelectedInstallation>;
  today: InstallationDate;
  hasSubmittedScheduleInstall: boolean;
  PALInstallationDates: ScheduleR0[];
};

export const initialScheduleInstallationState: ScheduleInstallationState = {
  availableInstallationDates: {} as AvailableInstallationDates,
  calendarDate: { month: new Date().getMonth() + 1, year: new Date().getFullYear() },
  loadingInstallationDates: true,
  selectedInstallation: { value: defaultInstallation, valid: null, hintText: '' },
  today: {
    month: null,
    year: null,
    day: null,
  },
  hasSubmittedScheduleInstall: false,
  PALInstallationDates: [],
};

export type AvailableInstallationDates = Record<
  string,
  {
    timezone: string;
    day: number;
    month: MonthsOfYear;
    year: number;
    timeSlots: Record<string, { from: string; to: string; selected: boolean }>;
  }
>;

export type CalendarDate = {
  month: MonthsOfYear;
  year: number;
};

export interface InstallationDate {
  month: number | null;
  day: number | null;
  year: number | null;
}

export interface SelectedInstallation extends InstallationDate {
  timezone: string;
  arrivalWindow: string;
  note: string;
}

export enum MonthsOfYear {
  JANUARY = 1,
  FEBRUARY,
  MARCH,
  APRIL,
  MAY,
  JUNE,
  JULY,
  AUGUST,
  SEPTEMBER,
  OCTOBER,
  NOVEMBER,
  DECEMBER,
}
